import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCalendarSearch = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M20.5 4H17V2.5C17 2.22 16.78 2 16.5 2C16.22 2 16 2.22 16 2.5V4H8V2.5C8 2.22 7.78 2 7.5 2C7.22 2 7 2.22 7 2.5V4H3.5C3.22 4 3 4.22 3 4.5V19.5C3 19.78 3.22 20 3.5 20H20.5C20.78 20 21 19.78 21 19.5V4.5C21 4.22 20.78 4 20.5 4ZM7 5V6.5C7 6.78 7.22 7 7.5 7C7.78 7 8 6.78 8 6.5V5H16V6.5C16 6.78 16.22 7 16.5 7C16.78 7 17 6.78 17 6.5V5H20V8H4V5H7ZM4 19V9H20V19H4Z'
      fill='none'
    />
    <path d='M8 15H7V16H8V15Z' fill='none' />
    <path d='M11 15H10V16H11V15Z' fill='none' />
    <path d='M14 15.01H13V16.01H14V15.01Z' fill='none' />
    <path d='M8 12H7V13H8V12Z' fill='none' />
    <path d='M11 12H10V13H11V12Z' fill='none' />
    <path d='M14 12.01H13V13.01H14V12.01Z' fill='none' />
    <path d='M15 14H18V11H15V14ZM16 12H17V13H16V12Z' fill='none' />
  </svg>
);
export default SvgCalendarSearch;
